import { useState } from 'react'
import Chart from 'react-apexcharts'

export default function StockChart({ chartData, symbol }) {
  const {day, week, year} = chartData
  const [dateFormat, setDateFormat] = useState("24h")
  const color = determineTimeFormat()[determineTimeFormat().length - 1].y - determineTimeFormat()[0].y > 0 ? '#26C281' : '#ED3419'

  const options = {
    colors: [color],
    title: {
      text: symbol,
      align: 'center',
      style: {
        fontSize: '24px'
      }
    },
    chart: {
      id: 'stock data',
      animations: {
        speed: 1300
      }
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: false
      }
    },
    tooltip: {
      x: {
        format: 'MMM dd HH:MM'
      }
    }
  }

  function determineTimeFormat() {
    switch(dateFormat) {
      case '24h':
        return day
      case '7d':
        return week
      case '1y':
        return year
      default:
        return day
    }
  }

  const series = [{
    name: symbol,
      data: determineTimeFormat()
  }]

  function renderButtonSelect(button) {
    const classes = 'btn m-1 '
    return button === dateFormat ? classes + 'btn-primary' : classes + 'btn-outline-primary'
  }

  return (
    <div className='my-5 p-4 shadow-sm bg-white'>
      <Chart
        options={options}
        series={series}
        type='area'
        width='100%'
      />
      <div>
        <button className={renderButtonSelect('24h')} onClick={() => setDateFormat('24h')}>24h</button>
        <button className={renderButtonSelect('7d')} onClick={() => setDateFormat('7d')}>7d</button>
        <button className={renderButtonSelect('1y')} onClick={() => setDateFormat('1y')}>1y</button>
      </div>
    </div>
  )
}
